const language = {
	spanish: {
		header_title: "Noticias y ",
		header_span_title: "Actualidad",
		bold_text:
			"¡Localizamos las noticias más relevantes en el campo de la Geolocalización! Conoce nuestros próximos lanzamientos de innovación tecnológica y más.",
		link_text: "LEER NOTICIA",
		final_button_text: "Cargar más noticias",
	},
	english: {
		header_title: "News and ",
		header_span_title: "Current Events",
		bold_text:
			"¡We locate the most relevant news in the field of Geolocation! Learn about our upcoming technological innovation releases and more.",
		link_text: "READ NEWS",
		final_button_text: "Load more news",
	},
};

export default language;